/**
 * API version constants — the contract between the Eloquor backend and any
 * client that talks to it.
 *
 * - Backend mounts routes under `/api/v${API_VERSION.major}/…` and stamps
 *   every response with `X-API-Version: ${API_VERSION_STRING}`.
 * - Frontend embeds this same constant at build time. On every response, it
 *   compares the major component of the header to its embedded major; on
 *   mismatch it dispatches a `versionmismatch` event that surfaces a
 *   non-dismissable "please refresh" banner.
 *
 * Versioning rules:
 *   major — breaking change (URL prefix bumps; old prefix kept alive in
 *           parallel for one frontend release cycle).
 *   minor — additive field (frontend tolerates unknown keys; no banner).
 *   patch — internal / bug-fix only.
 *
 * Bump policy: edit this file in the SAME PR as the change. CI compares the
 * frontend-built version to the backend-served version and fails the deploy
 * if they disagree on major.
 */
export const API_VERSION = {
    major: 0,
    minor: 8,
    patch: 0,
};
export const API_VERSION_STRING = `${API_VERSION.major}.${API_VERSION.minor}.${API_VERSION.patch}`;
/** HTTP header carrying the version string on every API response. */
export const API_VERSION_HEADER = 'X-API-Version';
//# sourceMappingURL=version.js.map